import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Accordion Default"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "accordion faq-wrapper",
                id: "accordionExample"
              }, [
                _createElementVNode("div", { class: "accordion-item" }, [
                  _createElementVNode("h2", { class: "accordion-header" }, [
                    _createElementVNode("button", {
                      class: "accordion-button",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#collapseOne",
                      "aria-expanded": "true",
                      "aria-controls": "collapseOne"
                    }, " Accordion Item #1 ")
                  ]),
                  _createElementVNode("div", {
                    id: "collapseOne",
                    class: "accordion-collapse collapse show",
                    "data-bs-parent": "#accordionExample"
                  }, [
                    _createElementVNode("div", { class: "accordion-body" }, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "This is the first item's accordion body."),
                        _createTextVNode(" It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the "),
                        _createElementVNode("code", null, ".accordion-body"),
                        _createTextVNode(", though the transition does limit overflow. ")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "accordion-item" }, [
                  _createElementVNode("h2", { class: "accordion-header" }, [
                    _createElementVNode("button", {
                      class: "accordion-button collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#collapseTwo",
                      "aria-expanded": "false",
                      "aria-controls": "collapseTwo"
                    }, " Accordion Item #2 ")
                  ]),
                  _createElementVNode("div", {
                    id: "collapseTwo",
                    class: "accordion-collapse collapse",
                    "data-bs-parent": "#accordionExample"
                  }, [
                    _createElementVNode("div", { class: "accordion-body" }, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "This is the second item's accordion body."),
                        _createTextVNode(" It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the "),
                        _createElementVNode("code", null, ".accordion-body"),
                        _createTextVNode(", though the transition does limit overflow. ")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "accordion-item" }, [
                  _createElementVNode("h2", { class: "accordion-header" }, [
                    _createElementVNode("button", {
                      class: "accordion-button collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#collapseThree",
                      "aria-expanded": "false",
                      "aria-controls": "collapseThree"
                    }, " Accordion Item #3 ")
                  ]),
                  _createElementVNode("div", {
                    id: "collapseThree",
                    class: "accordion-collapse collapse",
                    "data-bs-parent": "#accordionExample"
                  }, [
                    _createElementVNode("div", { class: "accordion-body" }, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "This is the third item's accordion body."),
                        _createTextVNode(" It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the "),
                        _createElementVNode("code", null, ".accordion-body"),
                        _createTextVNode(", though the transition does limit overflow. ")
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<div class=\"accordion faq-wrapper\" id=\"accordionExample\">\n<div class=\"accordion-item\">\n<h2 class=\"accordion-header\">\n<button class=\"accordion-button\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#collapseOne\" aria-expanded=\"true\" aria-controls=\"collapseOne\">\nAccordion Item #1\n</button>\n</h2>\n<div id=\"collapseOne\" class=\"accordion-collapse collapse show\" data-bs-parent=\"#accordionExample\">\n<div class=\"accordion-body\">\n<p><strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.</p>\n</div>\n</div>\n</div>\n<div class=\"accordion-item\">\n<h2 class=\"accordion-header\">\n<button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#collapseTwo\" aria-expanded=\"false\" aria-controls=\"collapseTwo\">\nAccordion Item #2\n</button>\n</h2>\n<div id=\"collapseTwo\" class=\"accordion-collapse collapse\" data-bs-parent=\"#accordionExample\">\n<div class=\"accordion-body\">\n<p><strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS \t\ttransitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.</p>\n</div>\n</div>\n</div>\n<div class=\"accordion-item\">\n<h2 class=\"accordion-header\">\n<button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#collapseThree\" aria-expanded=\"false\" aria-controls=\"collapseThree\">\nAccordion Item #3\n</button>\n</h2>\n<div id=\"collapseThree\" class=\"accordion-collapse collapse\" data-bs-parent=\"#accordionExample\">\n<div class=\"accordion-body\">\n<p><strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.</p>\n</div>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Accordion Flush"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "accordion accordion-flush faq-wrapper",
                id: "accordionFlushExample"
              }, [
                _createElementVNode("div", { class: "accordion-item" }, [
                  _createElementVNode("h2", { class: "accordion-header" }, [
                    _createElementVNode("button", {
                      class: "accordion-button collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#flush-collapseOne",
                      "aria-expanded": "false",
                      "aria-controls": "flush-collapseOne"
                    }, " Accordion Item #1 ")
                  ]),
                  _createElementVNode("div", {
                    id: "flush-collapseOne",
                    class: "accordion-collapse collapse",
                    "data-bs-parent": "#accordionFlushExample"
                  }, [
                    _createElementVNode("div", { class: "accordion-body" }, [
                      _createElementVNode("p", null, [
                        _createTextVNode(" Placeholder content for this accordion, which is intended to demonstrate the "),
                        _createElementVNode("code", null, ".accordion-flush"),
                        _createTextVNode(" class. This is the first item's accordion body. ")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "accordion-item" }, [
                  _createElementVNode("h2", { class: "accordion-header" }, [
                    _createElementVNode("button", {
                      class: "accordion-button collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#flush-collapseTwo",
                      "aria-expanded": "false",
                      "aria-controls": "flush-collapseTwo"
                    }, " Accordion Item #2 ")
                  ]),
                  _createElementVNode("div", {
                    id: "flush-collapseTwo",
                    class: "accordion-collapse collapse",
                    "data-bs-parent": "#accordionFlushExample"
                  }, [
                    _createElementVNode("div", { class: "accordion-body" }, [
                      _createElementVNode("p", null, [
                        _createTextVNode(" Placeholder content for this accordion, which is intended to demonstrate the "),
                        _createElementVNode("code", null, ".accordion-flush"),
                        _createTextVNode(" class. This is the second item's accordion body. Let's imagine this being filled with some actual content. ")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "accordion-item" }, [
                  _createElementVNode("h2", { class: "accordion-header" }, [
                    _createElementVNode("button", {
                      class: "accordion-button collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#flush-collapseThree",
                      "aria-expanded": "false",
                      "aria-controls": "flush-collapseThree"
                    }, " Accordion Item #3 ")
                  ]),
                  _createElementVNode("div", {
                    id: "flush-collapseThree",
                    class: "accordion-collapse collapse",
                    "data-bs-parent": "#accordionFlushExample"
                  }, [
                    _createElementVNode("div", { class: "accordion-body" }, [
                      _createElementVNode("p", null, [
                        _createTextVNode(" Placeholder content for this accordion, which is intended to demonstrate the "),
                        _createElementVNode("code", null, ".accordion-flush"),
                        _createTextVNode(" class. This is the third item's accordion body. Nothing more exciting happening here in terms of content, but just filling up the space to make it look, at least at first glance, a bit more representative of how this would look in a real-world application. ")
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<div class=\"accordion accordion-flush faq-wrapper\" id=\"accordionFlushExample\">\n<div class=\"accordion-item\">\n<h2 class=\"accordion-header\">\n<button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#flush-collapseOne\" aria-expanded=\"false\" aria-controls=\"flush-collapseOne\">\nAccordion Item #1\n</button>\n</h2>\n<div id=\"flush-collapseOne\" class=\"accordion-collapse collapse\" data-bs-parent=\"#accordionFlushExample\">\n<div class=\"accordion-body\">\n<p>Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the first item's accordion body.</p>\n</div>\n</div>\n</div>\n<div class=\"accordion-item\">\n<h2 class=\"accordion-header\">\n<button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#flush-collapseTwo\" aria-expanded=\"false\" aria-controls=\"flush-collapseTwo\">\nAccordion Item #2\n</button>\n</h2>\n<div id=\"flush-collapseTwo\" class=\"accordion-collapse collapse\" data-bs-parent=\"#accordionFlushExample\">\n<div class=\"accordion-body\">\n<p>Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the second item's accordion body. Let's imagine this being filled with some actual content.</p>\n</div>\n</div>\n</div>\n<div class=\"accordion-item\">\n<h2 class=\"accordion-header\">\n<button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#flush-collapseThree\" aria-expanded=\"false\" \taria-controls=\"flush-collapseThree\">\nAccordion Item #3\n</button>\n</h2>\n<div id=\"flush-collapseThree\" class=\"accordion-collapse collapse\" data-bs-parent=\"#accordionFlushExample\">\n<div class=\"accordion-body\">\n<p>Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the third item's accordion body. Nothing more exciting happening here in terms of content, but just filling up the space to make it look, at least at first glance, a bit more representative of how this would look in a real-world application.</p>\n</div>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Accordion Always open"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "accordion faq-wrapper",
                id: "accordionPanelsStayOpenExample"
              }, [
                _createElementVNode("div", { class: "accordion-item" }, [
                  _createElementVNode("h2", { class: "accordion-header" }, [
                    _createElementVNode("button", {
                      class: "accordion-button",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#panelsStayOpen-collapseOne",
                      "aria-expanded": "true",
                      "aria-controls": "panelsStayOpen-collapseOne"
                    }, " Accordion Item #1 ")
                  ]),
                  _createElementVNode("div", {
                    id: "panelsStayOpen-collapseOne",
                    class: "accordion-collapse collapse show"
                  }, [
                    _createElementVNode("div", { class: "accordion-body" }, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "This is the first item's accordion body."),
                        _createTextVNode(" It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the "),
                        _createElementVNode("code", null, ".accordion-body"),
                        _createTextVNode(", though the transition does limit overflow. ")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "accordion-item" }, [
                  _createElementVNode("h2", { class: "accordion-header" }, [
                    _createElementVNode("button", {
                      class: "accordion-button collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#panelsStayOpen-collapseTwo",
                      "aria-expanded": "false",
                      "aria-controls": "panelsStayOpen-collapseTwo"
                    }, " Accordion Item #2 ")
                  ]),
                  _createElementVNode("div", {
                    id: "panelsStayOpen-collapseTwo",
                    class: "accordion-collapse collapse"
                  }, [
                    _createElementVNode("div", { class: "accordion-body" }, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "This is the second item's accordion body."),
                        _createTextVNode(" It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the "),
                        _createElementVNode("code", null, ".accordion-body"),
                        _createTextVNode(", though the transition does limit overflow. ")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "accordion-item" }, [
                  _createElementVNode("h2", { class: "accordion-header" }, [
                    _createElementVNode("button", {
                      class: "accordion-button collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#panelsStayOpen-collapseThree",
                      "aria-expanded": "false",
                      "aria-controls": "panelsStayOpen-collapseThree"
                    }, " Accordion Item #3 ")
                  ]),
                  _createElementVNode("div", {
                    id: "panelsStayOpen-collapseThree",
                    class: "accordion-collapse collapse"
                  }, [
                    _createElementVNode("div", { class: "accordion-body" }, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "This is the third item's accordion body."),
                        _createTextVNode(" It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the "),
                        _createElementVNode("code", null, ".accordion-body"),
                        _createTextVNode(", though the transition does limit overflow. ")
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<div class=\"accordion faq-wrapper\" id=\"accordionPanelsStayOpenExample\">\n<div class=\"accordion-item\">\n<h2 class=\"accordion-header\">\n<button class=\"accordion-button\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#panelsStayOpen-collapseOne\" aria-expanded=\"true\" aria-controls=\"panelsStayOpen-collapseOne\">\nAccordion Item #1\n</button>\n</h2>\n\n<div id=\"panelsStayOpen-collapseOne\" class=\"accordion-collapse collapse show\">\n<div class=\"accordion-body\">\n<p><strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.</p>\n</div>\n</div>\n</div>\n\n<div class=\"accordion-item\">\n<h2 class=\"accordion-header\">\n<button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#panelsStayOpen-collapseTwo\" aria-expanded=\"false\" aria-controls=\"panelsStayOpen-collapseTwo\">\nAccordion Item #2\n</button>\n</h2>\n\n<div id=\"panelsStayOpen-collapseTwo\" class=\"accordion-collapse collapse\">\n<div class=\"accordion-body\">\n<p><strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.</p>\n</div>\n</div>\n</div>\n\n<div class=\"accordion-item\">\n<h2 class=\"accordion-header\">\n<button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#panelsStayOpen-collapseThree\" aria-expanded=\"false\" aria-controls=\"panelsStayOpen-collapseThree\">\nAccordion Item #3\n</button>\n</h2>\n\n<div id=\"panelsStayOpen-collapseThree\" class=\"accordion-collapse collapse\">\n<div class=\"accordion-body\">\n<p><strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.</p>\n</div>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}